import { render, staticRenderFns } from "./FooterCreditLink.vue?vue&type=template&id=7e7abbde&"
import script from "./FooterCreditLink.vue?vue&type=script&lang=js&"
export * from "./FooterCreditLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports